function AppController ( $document, $window, $scope, $location, $rootScope, $metrika, $routeParams, AppService, AppConfigService, SearchService, CategoriesService, ContentService, BannersService, CartService, AdditionalGoodsService )
{
    'ngInject';
    var vm = this;

    var path = $location.path();

    vm.appConfig = AppConfigService;
    vm.categoriesList = [];
    vm.categories = CategoriesService;
    vm.content = ContentService;
    vm.addGoods = AdditionalGoodsService;
    vm.cartService = CartService;
    vm.search = SearchService;

    $rootScope.$on('$viewContentLoaded', function(){
        bioEp.init({
            cookieExp: 30,
            showOncePerSession: true,
            delay: 0,
            showPopupCallback: vm.showOfferWindow
        });
    });

    vm.showOfferWindow = function () {
        if (!vm.appConfig.options.config.banner_on_close.off) {
            $('#modalOffer').modal({
                show: true
            });
        }
    };

    $rootScope.$on( '$routeChangeSuccess', function( event, next, current )
    {
        BannersService.checkBanners();

        var newPath = $location.path();

        $metrika.counterIsLoaded().then( function (counter)
        {
            return counter.hit(newPath, {
                referer: path
            });
        });
        /* off gtag after 24.02.22
            if ( vm.appConfig.options.config && vm.appConfig.options.config.google_analytics_id != "" )
            {
                gtag('config', vm.appConfig.options.config.google_analytics_id, {'page_path': path});
                gtag('config', 'AW-1001962874');
            }
        */
        //fbq('track', 'PageView'); //off Facebook pixel after 24.02.22

        path = newPath;
    });

    vm.getKeynote = function () {
        return vm.appConfig.options.config.keynote;
    };

    $scope.$watch(
        function () {
            return vm.search.options.searchString;
        },
        function (newVal) {
            vm.search.search(newVal);
        }
    );

    vm.getFaviconPath = function () {
        if (vm.appConfig.options.config && vm.appConfig.options.config.favicon) {
            return vm.appConfig.options.config.favicon;
        } else {
            return '/favicon.ico';
        }
    };

    vm.getFaviconType = function () {
        if (vm.appConfig.options.config && vm.appConfig.options.config.favicon_type) {
            return vm.appConfig.options.config.favicon_type;
        } else {
            return '/image/x-icon';
        }
    };

    vm.needCartIcon = function () {
        return vm.appConfig.options.isInit !== false &&
            $location.$$path !== '/cart' &&
            $location.$$path !== '/bouquet-on-photo' &&
            $location.$$path !== '/collect' &&
            $location.$$path.indexOf('/success') &&
            $location.$$path !== '/maintenance';
    }

    $scope.isAccessibilityMode = false;
    $scope.isImagesHidden = false;
    $scope.isDarkMode = false;

    $scope.toggleAccessibility = function() {
        $scope.isAccessibilityMode = !$scope.isAccessibilityMode;
        if ($scope.isAccessibilityMode) {
            $document[0].body.classList.add('accessibility-mode');
            localStorage.setItem('accessibilityMode', 'true');
        } else {
            $document[0].body.classList.remove('accessibility-mode', 'hide-images-mode', 'dark-mode');
            localStorage.removeItem('accessibilityMode');
            localStorage.removeItem('imagesHidden');
            localStorage.removeItem('darkMode');
            $scope.setFontSize('font-normal');
            angular.forEach(angular.element('.alt-text-replacement'), function(el) {
                angular.element(el).remove();
            });
            $scope.isAccessibilityMode = false;
            $scope.isImagesHidden = false;
            $scope.isDarkMode = false;
            window.location.reload(); // ?лучшее решение для верного применения шрифтов
        }
    };

    if (localStorage.getItem('accessibilityMode')) {
        $scope.isAccessibilityMode = true;
        $document[0].body.classList.add('accessibility-mode');
        if (localStorage.getItem('imagesHidden') === 'true') {
            $scope.isImagesHidden = true;
            $document[0].body.classList.add('hide-images-mode');
            angular.element($window).on('load', function() {
                angular.forEach(angular.element('img'), function(img) {
                    var altText = img.getAttribute('alt');
                    if (altText && altText !== '') {
                        var span = angular.element('<span class="alt-text-replacement"></span>');
                        span.text(altText);
                        angular.element(img).after(span);
                    }
                });
            });
        }
        if (localStorage.getItem('darkMode') === 'true') {
            $scope.isDarkMode = true;
            $document[0].body.classList.remove('accessibility-mode');
            $document[0].body.classList.add('dark-mode');
        } else {
            $document[0].body.classList.remove('dark-mode');
            $document[0].body.classList.add('accessibility-mode');
        }
    }

    $scope.setFontSize = function(sizeClass) {
        localStorage.setItem('fontSize', sizeClass);
        if (localStorage.getItem('accessibilityMode')) {

            var body = angular.element(document.body);
            body.removeClass('font-normal font-large font-xlarge');

            body.addClass(sizeClass);

            var html = angular.element(document.documentElement);
            html.removeClass('font-normal font-large font-xlarge');
            html.addClass(sizeClass);
        }
    };

    $scope.toggleImagesVisibility = function() {
        $scope.isImagesHidden = !$scope.isImagesHidden;

        if ($scope.isImagesHidden && localStorage.getItem('accessibilityMode')) {
            $document[0].body.classList.add('hide-images-mode');
            localStorage.setItem('imagesHidden', 'true');

            angular.forEach(angular.element('img'), function(img) {
                var altText = img.getAttribute('alt');
                if (altText && altText !== '') {
                    var span = angular.element('<span class="alt-text-replacement"></span>');
                    span.text(altText);
                    angular.element(img).after(span);
                }
            });
        } else {
            $document[0].body.classList.remove('hide-images-mode');
            localStorage.removeItem('imagesHidden');

            angular.forEach(angular.element('.alt-text-replacement'), function(el) {
                angular.element(el).remove();
            });
        }
    };

    $scope.toggleColorScheme = function() {
        if (!$scope.isAccessibilityMode) return;

        $scope.isDarkMode = !$scope.isDarkMode;
        if ($scope.isDarkMode && localStorage.getItem('accessibilityMode')) {
            $document[0].body.classList.remove('accessibility-mode');
            $document[0].body.classList.add('dark-mode');
            localStorage.setItem('darkMode', 'true');
        }
        if (!$scope.isDarkMode && localStorage.getItem('accessibilityMode')) {
            $document[0].body.classList.remove('dark-mode');
            $document[0].body.classList.add('accessibility-mode');
            localStorage.removeItem('darkMode');
        }
    };


    function initFontSize() {
        var savedSize = localStorage.getItem('fontSize') || 'font-normal';
        $scope.setFontSize(savedSize);
    }

    initFontSize();
}

module.exports = AppController;